import React, { Component } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import NavBar from './Header/navbar'
import Contact from './Contact/contact'
import ContactDetails from './Contact/contactDetails'

import Home from './Home/home'
import Construction from './Construction/construction'
import Facade from './Facades/facade'
import Other from './OtherServices/other'

require('dotenv').config()

class App extends Component {

  render () {
    return (
      <HashRouter basename={process.env.PUBLIC_URL}>
        <div>
         
          <Switch>
          {/* <Route exact path={process.env.PUBLIC_URL + '/'} component={Home} />
          <Route  path={process.env.PUBLIC_URL + '/constructions'} component={Construction} />
          <Route  path={process.env.PUBLIC_URL + '/facades'} component={Facade} />
          <Route  path={process.env.PUBLIC_URL + '/other'} component={Other} />
          <Route path={process.env.PUBLIC_URL + '*'} component={Home} /> */}
             <Route exact path='/mtd' component={Home} />
            <Route path='/constructions' component={Construction} />
            <Route path='/facades' component={Facade} />
            <Route path='/other' component={Other} />
            <Route exact path='/' component={Home} /> 
            <Route path='*' component={Home} />
          </Switch>
          <Contact />
          <ContactDetails />
        </div>
      </HashRouter>
    )
  }
}

export default App
